import * as yup from 'yup';
export const commonCalendarEventMaintenanceValidation: { [x: string]: any; } = {
  eventType: yup.string().required("Missing."),
  eventDate: yup.string().required("Missing."),
};
export const createCalendarEventMaintenanceValidation: { [x: string]: any; } = {
  ...commonCalendarEventMaintenanceValidation,
};
export const createCalendarEventMaintenanceValidationSchema = yup.object().shape(createCalendarEventMaintenanceValidation); 
